/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import s from "./Modal.module.css";
import { FC, MouseEventHandler } from "react";

// variant: "full-page" || "default"

type Props = {
  content: string
  isOpen?: boolean
  onCancel?: MouseEventHandler<HTMLDivElement>
  variant?: "default" | "full-page"
  showCloseButton?: boolean
}

const Modal: FC<Props> = ({ content, isOpen, onCancel, variant = "default", showCloseButton = true }) => {
  if (variant === "default") {
    return (
      <div className={cn(s.root, isOpen ? s.open : s.hide)} role="document">
        {/* <div className="p-5 bg-primary-800">
          <div>{content}</div>
        </div> */}
        {content}
      </div>
    );
  }
  if (variant === "full-page") {
    return (
      <div className={isOpen ? "relative z-20" : "hidden"} role="document">
        {showCloseButton && (
          <div
            role="button"
            onClick={onCancel}
            className="text-lg absolute top-5 end-5 z-10"
          >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            />
            <path
              fillRule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            />
          </svg>
          </div>
        )}
        <div>{content}</div>
      </div>
    );
  }
};

export default Modal;
